"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./LoadingText.css");
exports.default = react_1.default.memo(function LoadingText(props) {
    var type = props.type, size = props.size, lines = props.lines, classNameProps = props.className;
    return (react_1.default.createElement(react_1.default.Fragment, null, Array.from(Array(lines || 1), function (_, index) { return (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)([
            'dui-loading-text',
            classNameProps,
            type,
            size === 'small' && 'dui-loading-text__small',
            size === 'medium' && 'dui-loading-text__medium',
            size === 'large' && 'dui-loading-text__large',
            size === 'full' && 'dui-loading-text__full'
        ]) })); })));
});
